import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.createNewSupplement;
export const createNewSupplementSelector = (state: RootState) => getState(state).data;
